export default __webpack_public_path__ + "static/media/P301 zu P303.f0556512.mp3";